/**
 * Integracje → Kalendarz „Stały link do rozmów": the one link every video consultation takes when
 * Google makes no Meet (owner, 28 October 2026). Shown by its host only — the link joins whoever
 * holds it (consultation-calls R7). The empty state's suggestion follows the platform. Pure.
 */

import { httpsLinkOf, shownHost } from '~/shared/lib/httpsLink';

export type StandingCallLinkView =
  | { readonly kind: 'empty'; readonly bodyKey: string }
  | { readonly kind: 'set'; readonly host: string };

export function standingCallLinkView(link: string | null | undefined, apple: boolean): StandingCallLinkView {
  const parsed = typeof link === 'string' ? httpsLinkOf(link.trim()) : null;
  if (parsed === null) {
    return {
      kind: 'empty',
      bodyKey: apple ? 'web:account.calendar.standing.emptyApple' : 'web:account.calendar.standing.emptyOther',
    };
  }
  return { kind: 'set', host: shownHost(parsed.host) };
}
